"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveScriptElement = resolveScriptElement;

var _typeGuards = require("@insided/shared/utils/typeGuards");

var SCRIPT_ELEMENT_ID = 'insided-preact-app';

function resolveScriptElement() {
  var scriptElement = document.getElementById(SCRIPT_ELEMENT_ID);

  if (!scriptElement || !(0, _typeGuards.isHtmlElement)(scriptElement)) {
    throw new Error("".concat(SCRIPT_ELEMENT_ID, " element not found"));
  }

  return scriptElement;
}